"use strict";

require('core-js/es6/symbol');

var DEFINE_PROPERTY = "define" + "Property";

function defineMatch(O, fn) {
  return Object[DEFINE_PROPERTY](O, Symbol.matches, {
    writable: false,
    configurable: false,
    enumerable: false,
    value: fn
  });
}

if (!Symbol.matches) {
  Object[DEFINE_PROPERTY](Symbol, "matches", {
    configurable: false,
    writable: false,
    value: Symbol("matches")
  });

  // Classes
  defineMatch(Function.prototype, function (x) {
    return x instanceof this;
  });
  // Primitives
  defineMatch(Number, function (x) {
    return typeof x === "number";
  });
  defineMatch(String, function (x) {
    return typeof x === "string";
  });
  defineMatch(Boolean, function (x) {
    return typeof x === "boolean";
  });
  // Regexp
  defineMatch(RegExp.prototype, function (x) {
    return this.test(x);
  });
  // Set
  if (typeof Set !== "undefined") {
    defineMatch(Set.prototype, function (x) {
      return this.has(x);
    });
  }
}module.exports = function isMatch(atom, discriminant) {
  return Boolean(atom != null && atom[Symbol.matches] ? atom[Symbol.matches](discriminant) : atom === discriminant);
};